var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-01",
    clipPath: "url(#clip0_402_610)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.56006 7.99992H14.8934M1.56006 7.99992C1.56006 11.6818 4.54483 14.6666 8.22673 14.6666M1.56006 7.99992C1.56006 4.31802 4.54483 1.33325 8.22673 1.33325M14.8934 7.99992C14.8934 11.6818 11.9086 14.6666 8.22673 14.6666M14.8934 7.99992C14.8934 4.31802 11.9086 1.33325 8.22673 1.33325M8.22673 1.33325C9.89425 3.15882 10.8419 5.52794 10.8934 7.99992C10.8419 10.4719 9.89425 12.841 8.22673 14.6666M8.22673 1.33325C6.55921 3.15882 5.61156 5.52794 5.56006 7.99992C5.61156 10.4719 6.55921 12.841 8.22673 14.6666",
    stroke: "#5732AB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.226562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthIcon);
export default __webpack_public_path__ + "static/media/earth_icon.c0b61535476442dc9572711dc2a60d50.svg";
export { ForwardRef as ReactComponent };